import { useTheme } from '@mui/styles';
import { stringToColor } from 'utils/helpers';
import { useMemo } from 'react';
import { MerchantChipType, avatarCommonProps, getSizeProps } from './components';

//  borderColor: string; color: string
export const useStringAvatarProps = ({ merchant, size }: { merchant: MerchantChipType; size: 'small' | 'medium' | 'large' }) => {
    const theme = useTheme();

    const bgcolor = useMemo(() => {
        return stringToColor(merchant.name);
    }, [merchant.name]);

    let shortName = useMemo(() => {
        const nameParts = merchant.name.split(' ');

        if (nameParts.length > 1) {
            return `${nameParts[0][0]}${nameParts[1][0]}`;
        }
        return nameParts[0].substring(0, 2);
    }, [merchant.name]);

    const color = useMemo(() => {
        return theme.palette.getContrastText(bgcolor);
    }, [bgcolor, theme.palette]);

    const finalProps = {
        sx: {
            bgcolor,
            color,
            ...avatarCommonProps,
            ...getSizeProps(size)
        },
        children: shortName.toUpperCase()
    };

    return finalProps;
};
